import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FontSizeKey = 'title' | 'text' | 'heading' | 'subHeading';

type FontSizeState = {
  title: number;
  text: number;
  heading: number;
  subHeading: number;
};

// NOTE: this slice is only consumed by FontSizeControll.tsx (a settings-screen
// preview). It must NOT drive CSS custom properties — `trackforce.scss` is the
// single source of truth for font sizing project-wide.
const initialState: FontSizeState = {
  title: 12,
  text: 12,
  heading: 24,
  subHeading: 18,
};

const fontSizeSlice = createSlice({
  name: 'fontSize',
  initialState,
  reducers: {
    setFontSizeValue(
      state,
      action: PayloadAction<{ key: FontSizeKey; value: number }>
    ) {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFontSizeValue } = fontSizeSlice.actions;
export default fontSizeSlice.reducer;
